import React, { Fragment, Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    TextField,
    Button,
    RadioGroup,
    Radio,
    FormControlLabel,
    MenuItem,
    Select,
    InputLabel,
    FormControl
} from '@material-ui/core';

import { Translate } from '../../Localization/Translate';
// import Api from '../../../nibeApi';

class Power extends Component {
    buildingTypeEnum = {
        renovation: 1,
        newBuilding: 2,
    }

    updateInputData(elementName, value, checkInt) {
        if (checkInt) {
            value = parseInt(value, 10);
            if (Number.isNaN(value)) {
                value = "";
            }
        }
        const powerValues = { ...this.props.powerValues };
        if (powerValues) {
            powerValues[elementName] = value;
            this.props.updateState("powerValues", powerValues);
        }
    }

    togglePowerState(powerIsKnown) {
        if (this.props.updateState) {
            this.props.updateState("powerIsKnown", powerIsKnown);
        }
    }

    handleBack = () => {
        const { updateState, activeStep } = this.props;
        if (updateState) {
            updateState("activeStep", activeStep - 1);
        }
    };

    render() {
        const ventilationTypes = ["mv", "co2", "wtw"];

        const classes = makeStyles(() => ({
            root: {
                width: '100%',
            },
        }));

        const { updateSteps } = this.props;
        return (
            <div>
                <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                    <Fragment>
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12} sm={12}>
                                {Translate('QuoteTool/step3/buildingtype')}
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <RadioGroup row={true}>
                                    <FormControlLabel
                                        value=""
                                        control={<Radio color="primary" />}
                                        label={Translate('QuoteTool/step3/renovation')}
                                        labelPlacement="end"
                                        checked={this.props.powerValues.buildingType === this.buildingTypeEnum.renovation}
                                        onClick={() => this.updateInputData('buildingType', this.buildingTypeEnum.renovation)}
                                    />
                                    <FormControlLabel
                                        value=""
                                        control={<Radio color="primary" />}
                                        label={Translate('QuoteTool/step3/newbuilding')}
                                        labelPlacement="end"
                                        checked={this.props.powerValues.buildingType === this.buildingTypeEnum.newBuilding}
                                        onClick={() => this.updateInputData('buildingType', this.buildingTypeEnum.newBuilding)}
                                    />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                    </Fragment>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={12}>
                            {Translate('QuoteTool/step3/quotepowerlabel')}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <RadioGroup
                                aria-label={Translate('QuoteTool/step3/quotepowerlabel')}
                                name={Translate('QuoteTool/step3/quotepowerlabel')}
                                className={classes.group}
                                row={true}
                            >
                                <FormControlLabel
                                    value="false"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/step3/quotepowercalclabel')}
                                    labelPlacement="end"
                                    onChange={() => this.togglePowerState(false)}
                                    checked={this.props.powerIsKnown != undefined && !this.props.powerIsKnown}
                                />
                                <FormControlLabel
                                    value="true"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/step3/quotepowerknownlabel')}
                                    labelPlacement="end"
                                    checked={this.props.powerIsKnown}
                                    onChange={() => this.togglePowerState(true)}
                                />

                            </RadioGroup>
                        </Grid>
                    </Grid>

                    {this.props.powerIsKnown &&
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12} sm={8} md={6}>
                                <TextField fullWidth variant="outlined" type="number" label={Translate("QuoteTool/step3/quotepowerknowninputlabel")} value={this.props.power} onChange={(event) => this.props.updateState("power", event.target.value)} /><br />
                            </Grid>
                        </Grid>
                    }
                    {this.props.powerIsKnown != undefined && !this.props.powerIsKnown &&
                        <> {this.props.powerValues.buildingType === this.buildingTypeEnum.newBuilding &&
                            <>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12} sm={8} md={6}>
                                        <TextField type="number" fullWidth variant="outlined" label={Translate("QuoteTool/step3/quotesurfacelabel")} value={this.props.powerValues.livingArea} onChange={(event) => this.updateInputData('livingArea', event.target.value, true)} />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        {Translate('QuoteTool/step3/quoteventilatiolabel')}
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <RadioGroup
                                            aria-label={Translate('QuoteTool/step3/quoteventilatiolabel')}
                                            name={Translate('QuoteTool/step3/quoteventilatiolabel')}
                                            className={classes.group}
                                            row={true}>
                                            {ventilationTypes && ventilationTypes.map(ventilationType => {
                                                return (
                                                    <FormControlLabel
                                                        key={ventilationType}
                                                        value=""
                                                        control={<Radio color="primary" />}
                                                        label={Translate("QuoteTool/step3/" + ventilationType + "label")}
                                                        labelPlacement="end"
                                                        checked={this.props.powerValues.ventilationValue === ventilationType}
                                                        onChange={() => this.updateInputData('ventilationValue', ventilationType)}
                                                    />
                                                )
                                            })}
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                            </>}


                            {this.props.powerValues.buildingType === this.buildingTypeEnum.renovation &&
                                <>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12} sm={6} md={6}>
                                            <FormControl className='nibe-power--margin-bottom'>
                                                <InputLabel id="building-year">{Translate('QuoteTool/step3/buildingyear')}</InputLabel>
                                                <Select
                                                    labelId="building-year"
                                                    value={this.props.powerValues.buildingYear}
                                                    onChange={(event) => {
                                                        this.updateInputData('buildingYear', event.target.value);
                                                    }}
                                                    autoWidth={true}
                                                    className="select__building-type"
                                                >
                                                    <MenuItem value={2000}>{Translate('QuoteTool/step3/2000tolater')}</MenuItem>
                                                    <MenuItem value={1990}>{Translate('QuoteTool/step3/1990to1999')}</MenuItem>
                                                    <MenuItem value={1900}>{Translate('QuoteTool/step3/earlierto1989')}</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                className='nibe-power--margin-bottom'
                                                type="number"
                                                fullWidth
                                                variant="outlined"
                                                label={Translate('QuoteTool/step3/gasusage')}
                                                value={this.props.powerValues.gasUsage}
                                                onChange={(event) => {
                                                    this.updateInputData('gasUsage', event.target.value);
                                                }} />
                                            <TextField
                                                className='nibe-power--margin-bottom'
                                                type="number"
                                                fullWidth
                                                variant="outlined"
                                                label={Translate('QuoteTool/step3/peopleinhousehold')}
                                                value={this.props.coolingAndWarmWaterObject.quotePersons}
                                                onChange={(event) => {
                                                    this.props.updateState('coolingAndWarmWaterObject', { ...this.props.coolingAndWarmWaterObject, quotePersons: event.target.value });
                                                }} />
                                        </Grid>
                                    </Grid>
                            </>}
                    </>}
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={12} md={6}>
                            {this.props.power > 0 && (this.props.power < this.props.selectedPumpObject.powerFrom || this.props.power > this.props.selectedPumpObject.powerTo) ?
                                <p className='nibe__error'>
                                    {Translate('QuoteTool/step3/powererror')} {this.props.selectedPumpObject.powerTo} {Translate('QuoteTool/general/kwh')}
                                </p>
                                : null}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleBack}
                                className={classes.button}
                            >
                                {Translate("QuoteTool/general/buttonback")}
                            </Button>&nbsp;

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={() => updateSteps(3, 3)}
                                className={classes.button}
                                disabled={!(this.props.power > 0 && this.props.powerValues.buildingType !== '')}
                            >
                                {Translate("QuoteTool/general/buttonnext")}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>

        );
    }
}

export default Power;